import script from "./ApoderadoExtraModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ApoderadoExtraModal.vue?vue&type=script&setup=true&lang=js"

import "./ApoderadoExtraModal.vue?vue&type=style&index=0&id=739ab2a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-739ab2a4"]])

export default __exports__